import { useState, useMemo } from "react";
import { Box, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  GridColDef,
  GridRowId,
  GridExperimentalPremiumFeatures,
  GridRowGroupingModel,
  GridRenderCellParams,
} from "@mui/x-data-grid-premium";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiOpenProcessMenu from "src/components/core-components/mui/ByzMuiOpenProcessMenu";
import DoctorDietCancelPopup from "./doctor-diet-cancel-popup";
import DoctorDietList from "./doctor-diet-list-popup";
import { useTranslate } from "src/locales";

//CKAPISIZ;452953;30.04.2025
interface DietRequestDataGridProps {
  filterStartDate: Date | null;
  filterEndDate: Date | null;
  gridRefreshKey: number;
}

export interface Patient {
  id: number;
  nameSurname: string;
  fileNo: string;
  admissionStatus: string;
  protocol: string;
  gender: string;
  age: number;
  diagnosis: string;
  admissionDate: string;
  dischargeDate: string;
  companion: string;
  department: string;
  doctor: string;
}

export interface DietRequest {
  id: number;
  patientId: number;
  dietTime: string;
  approvalStatus: string;
  name: string;
  meal: string;
  dietType: string;
  note: string;
  companion: string;
  actionTime: string;
  actionBy: string;
  approvalOrCancel: string;
}

const patients: Patient[] = [
  {
    id: 1,
    nameSurname: "Mertcan Işkar",
    fileNo: "5419",
    admissionStatus: "Yatış Kabul Edil",
    protocol: "1337",
    gender: "Erkek",
    age: 32,
    diagnosis: "E85,J55",
    admissionDate: "14.05.2025",
    dischargeDate: "",
    companion: "",
    department: "Genel Cerra",
    doctor: "Doktor",
  },
  {
    id: 2,
    nameSurname: "Sezer Özbek",
    fileNo: "5496",
    admissionStatus: "Yatış Kabul Edil",
    protocol: "741",
    gender: "Erkek",
    age: 36,
    diagnosis: "E85,J55",
    admissionDate: "12.05.2025",
    dischargeDate: "",
    companion: "",
    department: "Genel Cerra",
    doctor: "Doktor",
  },
  {
    id: 3,
    nameSurname: "Aydın Şahin",
    fileNo: "321",
    admissionStatus: "Yatış Kabul Edildi",
    protocol: "654",
    gender: "Erkek",
    age: 39,
    diagnosis: "E85,J55",
    admissionDate: "11.05.2025",
    dischargeDate: "",
    companion: "",
    department: "Genel Cerrahi",
    doctor: "Doktor",
  },
];

const initialDietRequests: DietRequest[] = [
  {
    id: 101,
    patientId: 1,
    dietTime: "17.05.2025",
    approvalStatus: "Gönderildi",
    name: "Normal",
    meal: "Sabah",
    dietType: "Normal",
    note: "",
    companion: "",
    actionTime: "17.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Beklemede",
  },
  {
    id: 102,
    patientId: 1,
    dietTime: "17.05.2025",
    approvalStatus: "Gönderildi",
    name: "Normal",
    meal: "Öğlen",
    dietType: "Sulu Yemek",
    note: "",
    companion: "",
    actionTime: "17.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Beklemede",
  },
  {
    id: 103,
    patientId: 1,
    dietTime: "17.05.2025",
    approvalStatus: "Gönderildi",
    name: "Tansiyon",
    meal: "Akşam",
    dietType: "Diyet Tansiyon",
    note: "",
    companion: "",
    actionTime: "17.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Beklemede",
  },
  {
    id: 104,
    patientId: 1,
    dietTime: "18.05.2025",
    approvalStatus: "Onaylandı",
    name: "Normal",
    meal: "Sabah",
    dietType: "Normal",
    note: "",
    companion: "",
    actionTime: "18.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Beklemede",
  },
  {
    id: 105,
    patientId: 1,
    dietTime: "18.05.2025",
    approvalStatus: "Onaylandı",
    name: "Normal",
    meal: "Öğlen",
    dietType: "Sulu Yemek",
    note: "",
    companion: "",
    actionTime: "18.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Beklemede",
  },
  {
    id: 106,
    patientId: 1,
    dietTime: "18.05.2025",
    approvalStatus: "Onaylandı",
    name: "Tansiyon",
    meal: "Akşam",
    dietType: "Diyet Tansiyon",
    note: "",
    companion: "",
    actionTime: "18.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Beklemede",
  },
  {
    id: 107,
    patientId: 1,
    dietTime: "19.05.2025",
    approvalStatus: "İptal",
    name: "Normal",
    meal: "Sabah",
    dietType: "Normal",
    note: "",
    companion: "",
    actionTime: "19.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Beklemede",
  },
  {
    id: 108,
    patientId: 1,
    dietTime: "19.05.2025",
    approvalStatus: "İptal",
    name: "Normal",
    meal: "Öğlen",
    dietType: "Sulu Yemek",
    note: "",
    companion: "",
    actionTime: "19.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Beklemede",
  },
  {
    id: 109,
    patientId: 1,
    dietTime: "19.05.2025",
    approvalStatus: "İptal",
    name: "Tansiyon",
    meal: "Akşam",
    dietType: "Diyet Tansiyon",
    note: "",
    companion: "",
    actionTime: "19.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Beklemede",
  },
  {
    id: 110,
    patientId: 2,
    dietTime: "17.05.2025",
    approvalStatus: "Gönderildi",
    name: "Normal",
    meal: "Sabah",
    dietType: "Normal",
    note: "",
    companion: "",
    actionTime: "17.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Onay",
  },
  {
    id: 111,
    patientId: 2,
    dietTime: "17.05.2025",
    approvalStatus: "Gönderildi",
    name: "Normal",
    meal: "Öğlen",
    dietType: "Sulu Yemek",
    note: "",
    companion: "",
    actionTime: "17.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Onay",
  },
  {
    id: 112,
    patientId: 2,
    dietTime: "17.05.2025",
    approvalStatus: "Gönderildi",
    name: "Tansiyon",
    meal: "Akşam",
    dietType: "Diyet Tansiyon",
    note: "",
    companion: "",
    actionTime: "17.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Onay",
  },
  {
    id: 113,
    patientId: 2,
    dietTime: "18.05.2025",
    approvalStatus: "Onaylandı",
    name: "Normal",
    meal: "Sabah",
    dietType: "Normal",
    note: "",
    companion: "",
    actionTime: "18.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Onay",
  },
  {
    id: 114,
    patientId: 2,
    dietTime: "18.05.2025",
    approvalStatus: "Onaylandı",
    name: "Normal",
    meal: "Öğlen",
    dietType: "Sulu Yemek",
    note: "",
    companion: "",
    actionTime: "18.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Onay",
  },
  {
    id: 115,
    patientId: 2,
    dietTime: "18.05.2025",
    approvalStatus: "Onaylandı",
    name: "Tansiyon",
    meal: "Akşam",
    dietType: "Diyet Tansiyon",
    note: "",
    companion: "",
    actionTime: "18.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Onay",
  },
  {
    id: 116,
    patientId: 2,
    dietTime: "19.05.2025",
    approvalStatus: "İptal",
    name: "Normal",
    meal: "Sabah",
    dietType: "Normal",
    note: "",
    companion: "",
    actionTime: "19.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Onay",
  },
  {
    id: 117,
    patientId: 2,
    dietTime: "19.05.2025",
    approvalStatus: "İptal",
    name: "Normal",
    meal: "Öğlen",
    dietType: "Sulu Yemek",
    note: "",
    companion: "",
    actionTime: "19.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Onay",
  },
  {
    id: 118,
    patientId: 2,
    dietTime: "19.05.2025",
    approvalStatus: "İptal",
    name: "Tansiyon",
    meal: "Akşam",
    dietType: "Diyet Tansiyon",
    note: "",
    companion: "",
    actionTime: "19.12.2024",
    actionBy: "BYZ",
    approvalOrCancel: "Onay",
  },
];

const groupingModel: GridRowGroupingModel = ["dietTime"];

export default function DietRequestDataGrid({
  filterStartDate,
  filterEndDate,
  gridRefreshKey,
}: DietRequestDataGridProps) {
  const theme = useTheme();
  const isTabletDown = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [expandedIds, setExpandedIds] = useState<GridRowId[]>([]);
  const [childSelected, setChildSelected] = useState<Record<number, boolean>>(
    {}
  );
  const [dietReqs, setDietReqs] = useState<DietRequest[]>(initialDietRequests);

  const [cancelPopupOpen, setCancelPopupOpen] = useState(false);
  const [cancelTargets, setCancelTargets] = useState<number[]>([]);

  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [historyDialogData, setHistoryDialogData] = useState<DietRequest[]>([]);
  const [selectedPatient, setselectedPatient] = useState<Patient | null>(null);
  const { t } = useTranslate();

  const filteredDietRequests = useMemo(() => {
    if (!filterStartDate && !filterEndDate) return dietReqs;

    const normStart = filterStartDate
      ? new Date(filterStartDate.setHours(0, 0, 0, 0))
      : null;
    const normEnd = filterEndDate
      ? new Date(filterEndDate.setHours(23, 59, 59, 999))
      : null;

    return dietReqs.filter((dr) => {
      const [d, m, y] = dr.dietTime.split(".");
      const dt = new Date(+y, +m - 1, +d);
      return (
        (normStart ? dt >= normStart : true) && (normEnd ? dt <= normEnd : true)
      );
    });
  }, [dietReqs, gridRefreshKey]);

  const filteredPatients = useMemo(
    () =>
      patients.filter((p) =>
        filteredDietRequests.some((dr) => dr.patientId === p.id)
      ),
    [filteredDietRequests]
  );

  const getColumnWidth = (
    mobileWidth: number,
    tabletWidth: number,
    desktopFlex = 1
  ) =>
    isMobile
      ? { width: mobileWidth, minWidth: mobileWidth }
      : isTabletDown
        ? { width: tabletWidth, minWidth: tabletWidth }
        : { flex: desktopFlex, minWidth: tabletWidth };

  const gridResponsiveSx = {
    "& .MuiDataGrid-columnHeader": {
      py: isMobile ? 0.5 : 0.75,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: isMobile ? "16px" : "18px",
    },
    "& .MuiDataGrid-cell": {
      fontSize: isMobile ? "12px" : "13px",
    },
  } as const;

  const parentColumns: GridColDef[] = [
    {
      field: "select",
      headerName: "",
      width: 48,
      renderCell: (params) => {
        const pid = params.id as number;
        const group = filteredDietRequests.filter((dr) => dr.patientId === pid);
        const all =
          group.length > 0 && group.every((dr) => childSelected[dr.id]);
        const some = !all && group.some((dr) => childSelected[dr.id]);
        return (
          <ByzMuiCheckBox
            checked={all}
            indeterminate={some}
            onChange={(e) => {
              const v = e.target.checked;
              setChildSelected((prev) => {
                const upd = { ...prev };
                group.forEach((dr) => (upd[dr.id] = v));
                return upd;
              });
            }}
          />
        );
      },
    },
    {
      field: "processMenu",
      headerName: "",
      width: 48,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const pid = params.id as number;
        const groupRows = filteredDietRequests.filter(
          (dr) => dr.patientId === pid
        );
        const selectedRows = groupRows.filter((dr) => childSelected[dr.id]);
        const selectedIds = selectedRows.map((r) => r.id);
        const allApproved =
          selectedRows.length > 0 &&
          selectedRows.every(
            (r) => r.approvalStatus === t("diet-requests-doctor.approved")
          );
        const allRejected =
          selectedRows.length > 0 &&
          selectedRows.every(
            (r) => r.approvalStatus === t("diet-requests-doctor.cancel")
          );
        const cancelLabel = allApproved
          ? t("diet-requests-doctor.cancel-approval-of-selected")
          : t("diet-requests-doctor.cancel-selected");
        return (
          <ByzMuiOpenProcessMenu
            hideHeaderTitle
            menuItems={[
              {
                label: t("diet-requests-doctor.approve-selected"),
                onClick: () => {
                  setDietReqs((prev) =>
                    prev.map((r) =>
                      selectedIds.includes(r.id)
                        ? {
                            ...r,
                            approvalStatus: t("diet-requests-doctor.approved"),
                          }
                        : r
                    )
                  );
                },
                disabled: selectedIds.length === 0 || allApproved,
              },
              {
                label: cancelLabel,
                onClick: () => {
                  setCancelTargets(selectedIds);
                  setCancelPopupOpen(true);
                },
                disabled: selectedIds.length === 0 || allRejected,
              },
              {
                label: t("diet-requests-doctor.view-diet-history"),
                disabled: selectedRows.length === 0,
                onClick: () => {
                  const patient = patients.find((p) => p.id === pid)!;
                  setselectedPatient(patient);
                  setHistoryDialogData(selectedRows);
                  setHistoryDialogOpen(true);
                },
              },
              {
                label: t("diet-requests-doctor.general-health-info"),
                onClick: () => {},
              },
            ]}
          />
        );
      },
    },
    {
      field: "expand",
      headerName: "",
      width: 48,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const isE = expandedIds.includes(params.id);
        return (
          <IconButton
            size="small"
            onClick={() =>
              isE
                ? setExpandedIds((es) => es.filter((x) => x !== params.id))
                : setExpandedIds((es) => [...es, params.id as GridRowId])
            }
          >
            {isE ? (
              <img src="/assets/icons/vector/vector-down.svg" alt="down" />
            ) : (
              <img src="/assets/icons/vector/vector-right.svg" alt="right" />
            )}
          </IconButton>
        );
      },
    },
    {
      field: "empty",
      headerName: "",
      width: 48,
    },
    {
      field: "nameSurname",
      headerName: t("diet-requests-doctor.patient-full-name"),
      ...getColumnWidth(180, 220),
    },
    { field: "fileNo", headerName: t("file-number"), ...getColumnWidth(110, 120) },
    {
      field: "admissionStatus",
      headerName: t("diet-requests-doctor.file-status"),
      ...getColumnWidth(160, 190),
    },
    {
      field: "protocol",
      headerName: t("diet-requests-doctor.protocol"),
      ...getColumnWidth(110, 120),
    },
    { field: "gender", headerName: t("gender"), ...getColumnWidth(100, 110) },
    { field: "age", headerName: t("age"), ...getColumnWidth(80, 90) },
    {
      field: "diagnosis",
      headerName: t("diet-requests-doctor.diagnoses"),
      ...getColumnWidth(140, 170),
    },
    {
      field: "admissionDate",
      headerName: t("diet-requests-doctor.admission-date"),
      ...getColumnWidth(140, 160),
    },
    {
      field: "dischargeDate",
      headerName: t("diet-requests-doctor.discharge-date"),
      ...getColumnWidth(140, 160),
    },
    {
      field: "companion",
      headerName: t("diet-requests-doctor.companion"),
      ...getColumnWidth(130, 150),
    },
    { field: "department", headerName: t("department"), ...getColumnWidth(150, 170) },
    { field: "doctor", headerName: t("doctor"), ...getColumnWidth(140, 160) },
  ];

  const childColumns: GridColDef[] = [
    {
      field: "detailExpand",
      headerName: "",
      width: 48,
      sortable: false,
      filterable: false,
      cellClassName: (params) => {
        const node: any = params.rowNode;
        return node.childrenExpanded === undefined ? "hide-detail-expand" : "";
      },
      renderCell: (params: GridRenderCellParams<DietRequest>) => {
        const node: any = params.rowNode;
        if (node.childrenExpanded === undefined) {
          return null;
        }
        const exp = node.childrenExpanded;
        const api: any = params.api;
        return (
          <IconButton
            size="small"
            onClick={() => api.setRowChildrenExpansion(node.id, !exp)}
          >
            {exp ? (
              <img src="/assets/icons/vector/vector-down.svg" alt="down" />
            ) : (
              <img src="/assets/icons/vector/vector-right.svg" alt="right" />
            )}
          </IconButton>
        );
      },
    },
    {
      field: "line",
      headerName: "",
      width: 48,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params: GridRenderCellParams<DietRequest>) => {
        const node: any = params.rowNode;
        const isGroupHeader = node.groupingField === "dietTime";
        const isFirstChild =
          node.parent != null &&
          (() => {
            const parentNode: any = params.api.getRowNode(node.parent);
            return parentNode?.children?.[0] === node.id;
          })();
        if (!isGroupHeader && !isFirstChild) return null;
        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src="/assets/icons/vector/line.svg" alt="Line" />
          </Box>
        );
      },
    },
    {
      field: "selectDetail",
      headerName: "",
      width: 48,
      sortable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams<DietRequest>) => {
        const dr = params.row;
        const node: any = params.rowNode;
        if (node.groupingField === "dietTime") {
          const key = node.groupingKey as string;
          const allRows = Array.from(
            params.api.getRowModels().values()
          ) as DietRequest[];
          const groupRows = allRows.filter((r) => r.dietTime === key);
          const all = groupRows.every((r) => childSelected[r.id]);
          const some = !all && groupRows.some((r) => childSelected[r.id]);
          return (
            <ByzMuiCheckBox
              checked={all}
              indeterminate={some}
              onChange={(e) => {
                const v = e.target.checked;
                setChildSelected((prev) => {
                  const upd = { ...prev };
                  groupRows.forEach((r) => (upd[r.id] = v));
                  return upd;
                });
              }}
            />
          );
        }
        return (
          <ByzMuiCheckBox
            checked={!!childSelected[dr.id]}
            onChange={(e) => {
              const v = e.target.checked;
              setChildSelected((prev) => ({ ...prev, [dr.id]: v }));
            }}
          />
        );
      },
    },
    {
      field: "processMenuDetail",
      headerName: "",
      width: 48,
      renderCell: (params: GridRenderCellParams<DietRequest>) => {
        const node: any = params.rowNode;
        if (node.groupingField === "dietTime") {
          const allRows = Array.from(
            params.api.getRowModels().values()
          ) as DietRequest[];
          const groupRows = allRows.filter(
            (r) => r.dietTime === node.groupingKey
          );
          const selectedRows = groupRows.filter((r) => childSelected[r.id]);
          const selectedIds = selectedRows.map((r) => r.id);
          const allApproved =
            selectedRows.length > 0 &&
            selectedRows.every(
              (r) => r.approvalStatus === t("diet-requests-doctor.approved")
            );
          const allRejected =
            selectedRows.length > 0 &&
            selectedRows.every(
              (r) => r.approvalStatus === t("diet-requests-doctor.cancel")
            );
          const cancelLabel = allApproved
            ? t("diet-requests-doctor.cancel-approval-of-selected")
            : t("diet-requests-doctor.cancel-selected");
          return (
            <ByzMuiOpenProcessMenu
              hideHeaderTitle
              menuItems={[
                {
                  label: t("diet-requests-doctor.approve-selected"),
                  onClick: () => {
                    setDietReqs((prev) =>
                      prev.map((r) =>
                        selectedIds.includes(r.id)
                          ? {
                              ...r,
                              approvalStatus: t(
                                "diet-requests-doctor.approved"
                              ),
                            }
                          : r
                      )
                    );
                  },
                  disabled: selectedIds.length === 0 || allApproved,
                },
                {
                  label: cancelLabel,
                  onClick: () => {
                    setCancelTargets(selectedIds);
                    setCancelPopupOpen(true);
                  },
                  disabled: selectedIds.length === 0 || allRejected,
                },
                {
                  label: t("diet-requests-doctor.view-diet-history"),
                  disabled: selectedRows.length === 0,
                  onClick: () => {
                    setHistoryDialogData(selectedRows);
                    setHistoryDialogOpen(true);
                  },
                },
              ]}
            />
          );
        }
        const dr = params.row;
        const cancelTwoLabel =
          dr.approvalStatus === t("diet-requests-doctor.approved")
            ? t("diet-requests-doctor.cancel-approval")
            : t("diet-requests-doctor.cancel-diet-request");
        return (
          <ByzMuiOpenProcessMenu
            hideHeaderTitle
            menuItems={[
              {
                label: t("diet-requests-doctor.approve-diet-request"),
                onClick: () => {
                  setDietReqs((prev) =>
                    prev.map((r) =>
                      r.id === dr.id
                        ? {
                            ...r,
                            approvalStatus: t("diet-requests-doctor.approved"),
                          }
                        : r
                    )
                  );
                },
                disabled:
                  dr.approvalStatus === t("diet-requests-doctor.approved"),
              },
              {
                label: cancelTwoLabel,
                onClick: () => {
                  setCancelTargets([dr.id]);
                  setCancelPopupOpen(true);
                },
                disabled:
                  dr.approvalStatus === t("diet-requests-doctor.cancel"),
              },
            ]}
          />
        );
      },
    },
    {
      field: "dietTime",
      headerName: t("diet-requests-doctor.diet-time"),
      ...getColumnWidth(130, 150),
    },
    {
      field: "approvalStatus",
      headerName: t("diet-requests-doctor.approval-status"),
      ...getColumnWidth(150, 170),
      cellClassName: (params) => {
        const v = params.value as string;
        if (v === t("diet-requests-doctor.sent")) return "status-sent";
        if (v === t("diet-requests-doctor.approved")) return "status-approved";
        if (v === t("diet-requests-doctor.cancel")) return "status-rejected";
        return "";
      },
    },
    { field: "name", headerName: t("diet-requests-doctor.name"), ...getColumnWidth(130, 150) },
    { field: "meal", headerName: t("meal"), ...getColumnWidth(120, 130) },
    {
      field: "dietType",
      headerName: t("diet-requests-doctor.diet-type"),
      ...getColumnWidth(150, 170),
    },
    { field: "note", headerName: t("note"), ...getColumnWidth(140, 160) },
    {
      field: "companion",
      headerName: t("diet-requests-doctor.companion"),
      ...getColumnWidth(130, 150),
    },
    {
      field: "actionTime",
      headerName: t("diet-requests-doctor.transaction-time"),
      ...getColumnWidth(150, 170),
    },
    {
      field: "actionBy",
      headerName: t("diet-requests-doctor.performed-by"),
      ...getColumnWidth(120, 140),
    },
    {
      field: "approvalOrCancel",
      headerName: t("diet-requests-doctor.approval-or-cancellation"),
      ...getColumnWidth(170, 200),
    },
  ];

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <ByzMuiDataGrid
          rows={filteredPatients}
          columns={parentColumns}
          getRowId={(r) => r.id}
          pageSize={5}
          pagination
          detailPanelExpandedRowIds={expandedIds}
          onDetailPanelExpandedRowIdsChange={setExpandedIds}
          columnVisibilityModel={{ __detail_panel_toggle__: false }}
          getDetailPanelContent={(params: any) => {
            const patient = params.row as Patient;
            const childRows = filteredDietRequests.filter(
              (dr) => dr.patientId === patient.id
            );
            return (
              <Box sx={{ width: "100%"}}>
                <ByzMuiDataGrid 
                  rows={childRows}
                  columns={childColumns}
                  getRowId={(r) => r.id}
                  hideFooterPagination
                  disableRowSelectionOnClick
                  experimentalFeatures={
                    {
                      rowGrouping: true,
                      columnPinning: true,
                    } as Partial<GridExperimentalPremiumFeatures>
                  }
                  rowGroupingModel={groupingModel}
                  pinnedColumns={{
                    left: [
                      "line",
                      "selectDetail",
                      "processMenuDetail",
                      "detailExpand",
                    ],
                    right: [],
                  }}
                  columnVisibilityModel={{ dietTime: false }}
                  groupingColDef={{
                    headerName: t("diet-requests-doctor.diet-time"),
                    width: 180,
                    leafField: "dietTime",
                    renderCell: (cellParams) => <span>{cellParams.value}</span>,
                  }}
                  sx={{
                    ...gridResponsiveSx,
                    "& .status-sent": { backgroundColor: "#AEADA64D" },
                    "& .status-approved": { backgroundColor: "#34C7594D" },
                    "& .status-rejected": { backgroundColor: "#C734364D" },
                  }}
                />
              </Box>
            );
          }}
          getDetailPanelHeight={() => {
            return "auto";
          }}
          sx={gridResponsiveSx}
        />
      </Box>
      <DoctorDietCancelPopup
        open={cancelPopupOpen}
        onClose={() => setCancelPopupOpen(false)}
        onConfirm={() => {
          setDietReqs((prev) =>
            prev.map((r) =>
              cancelTargets.includes(r.id)
                ? {
                    ...r,
                    approvalStatus:
                      r.approvalStatus === t("diet-requests-doctor.approved")
                        ? t("diet-requests-doctor.sent")
                        : t("diet-requests-doctor.cancel"),
                  }
                : r
            )
          );
          setCancelPopupOpen(false);
        }}
      />
      <DoctorDietList
        open={historyDialogOpen}
        onClose={() => setHistoryDialogOpen(false)}
        data={historyDialogData}
        patient={selectedPatient}
      />
    </>
  );
}
